export const TAB_MODS = {
  LIST: 'LIST',
  ADD: 'ADD',
  EDIT: 'EDIT',
  INFO: 'INFO',
};
